import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import logo from '../assets/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Poppins:wght@400;500;600&display=swap');

        .rf-header {
          background: #ffffffd1;
          position: sticky;
          top: 0;
          z-index: 100;
          padding: 0;
        }
        
        .rf-header__container {
          margin: 0 auto;
          max-width: 1200px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
        }
        
        .rf-header__logo {
          cursor: pointer;
          transition: opacity 0.3s ease;
          z-index: 110;
        }
        
        .rf-header__logo:hover {
          opacity: 0.8;
        }
        
        .rf-header__logo-image {
          height: 64px;
          width: 114px;
          object-fit: contain;
        }
        
        .rf-header__desktop-nav {
          display: flex;
          align-items: center;
          gap: 32px;
        }
        
        .rf-header__nav {
          display: flex;
          align-items: center;
          gap: 24px;
        }
        
        .rf-header__nav-link {
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          text-decoration: none;
          transition: color 0.3s ease;
          position: relative;
          padding: 8px 0;
        }
        
        .rf-header__nav-link:hover {
          color: #f58220;
        }
        
        .rf-header__nav-link:hover::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          height: 2px;
          background: #f58220;
          animation: rf-slideIn 0.3s ease;
        }
        
        @keyframes rf-slideIn {
          from {
            transform: scaleX(0);
          }
          to {
            transform: scaleX(1);
          }
        }
        
        .rf-header__contact-btn {
          background: #f58220;
          color: #ffffff;
          border: none;
          border-radius: 6px;
          padding: 12px 20px;
          font-family: 'Poppins';
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          white-space: nowrap;
          text-decoration: none;
          display: inline-block;
        }
        
        .rf-header__contact-btn:hover {
          background: #e6730d;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(245, 130, 32, 0.3);
        }
        
        .rf-header__contact-btn:active {
          transform: translateY(0);
        }

        .rf-header__mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
          z-index: 110;
          position: relative;
        }

        .rf-header__mobile-nav {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 105;
        }

        .rf-header__mobile-nav--open {
          display: block;
        }

        .rf-header__mobile-nav-content {
          position: absolute;
          top: 0;
          right: 0;
          height: 100vh;
          width: 280px;
          background: #ffffff;
          box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
          transform: translateX(100%);
          transition: transform 0.3s ease;
          display: flex;
          flex-direction: column;
          padding: 80px 30px 30px;
        }

        .rf-header__mobile-nav--open .rf-header__mobile-nav-content {
          transform: translateX(0);
        }

        .rf-header__mobile-nav-link {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          font-weight: 400;
          color: #000000;
          text-decoration: none;
          padding: 16px 0;
          border-bottom: 1px solid #f0f0f0;
          transition: color 0.3s ease;
        }

        .rf-header__mobile-nav-link:hover {
          color: #f58220;
        }

        .rf-header__mobile-nav-link:last-of-type {
          border-bottom: none;
        }

        .rf-header__mobile-contact-btn {
          background: #f58220;
          color: #ffffff;
          border: none;
          border-radius: 6px;
          padding: 14px 20px;
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          text-decoration: none;
          text-align: center;
          margin-top: 20px;
          transition: all 0.3s ease;
        }

        .rf-header__mobile-contact-btn:hover {
          background: #e6730d;
        }

        .rf-header__mobile-nav-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 280px;
          bottom: 0;
          background: transparent;
        }
        
        /* Tablet styles */
        @media (max-width: 1024px) {
          .rf-header__nav {
            gap: 16px;
          }
          
          .rf-header__container {
            padding: 0 16px;
          }
        }

        /* Mobile styles */
        @media (max-width: 768px) {
          .rf-header__desktop-nav {
            display: none;
          }

          .rf-header__mobile-menu-btn {
            display: block;
          }
          
          .rf-header__logo-image {
            height: 50px;
          }

          .rf-header__container {
            padding: 0 16px;
          }
        }
        
        @media (max-width: 480px) {
          .rf-header__logo-image {
            height: 81px;
          }

          .rf-header__container {
            padding: 0 12px;
          }

          .rf-header__mobile-nav-content {
            width: 100%;
            padding: 80px 20px 30px;
          }

          .rf-header__mobile-nav-overlay {
            display: none;
          }
        }

        /* Prevent body scroll when menu is open */
        body.rf-menu-open {
          overflow: hidden;
        }
      `}</style>

      <header className="rf-header">
        <div className="rf-header__container">
          <div className="rf-header__logo">
  <a href="/">
    <img 
      src={logo}
      alt="RealFlame PNG stove logo"
      className="rf-header__logo-image"
      width="180"
      height="60"
    />
  </a>
</div>

          
          {/* Desktop Navigation */}
          <div className="rf-header__desktop-nav">
            <nav className="rf-header__nav">
              <a href="/" className="rf-header__nav-link">Home</a>
              <a href="/about" className="rf-header__nav-link">About Us</a>
              <a href="/products" className="rf-header__nav-link">Products</a>
              <a href="/certifications" className="rf-header__nav-link">Certifications</a>
              {/* <a href="/clients" className="rf-header__nav-link">Clients</a> */}
              <a href="/useful-links" className="rf-header__nav-link">Watch & Shop</a>
              {/* <a href="/gallery" className="rf-header__nav-link">Gallery</a> */}
            </nav>
            
            <a href="/contact-us" className="rf-header__contact-btn">Contact Us</a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="rf-header__mobile-menu-btn" 
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`rf-header__mobile-nav ${isMenuOpen ? 'rf-header__mobile-nav--open' : ''}`}>
          <div className="rf-header__mobile-nav-overlay" onClick={closeMenu}></div>
          <div className="rf-header__mobile-nav-content">
            <a href="/" className="rf-header__mobile-nav-link" onClick={closeMenu}>Home</a>
            <a href="/about" className="rf-header__mobile-nav-link" onClick={closeMenu}>About Us</a>
            <a href="/products" className="rf-header__mobile-nav-link" onClick={closeMenu}>Products</a>
            <a href="/certifications" className="rf-header__mobile-nav-link" onClick={closeMenu}>Certifications</a>
            <a href="/useful-links" className="rf-header__mobile-nav-link" onClick={closeMenu}>Watch & Shop</a>
            {/* <a href="/clients" className="rf-header__mobile-nav-link" onClick={closeMenu}>Clients</a> */}
            {/*  <a href="/clients" className="rf-header__mobile-nav-link" onClick={closeMenu}>Clients</a>  */}
            {/* <a href="/gallery" className="rf-header__mobile-nav-link" onClick={closeMenu}>Gallery</a> */}
            <a href="/contact-us" className="rf-header__mobile-contact-btn" onClick={closeMenu}>
              Contact Us
            </a>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;